import useSWR from 'swr'
import arcadeApiClient from '../apiClients/arcadeApiClient'

export interface ObjectiveOption {
  id: string | number
  name: string
  description: string
  type: 'lesson' | 'pathway'
  pictureUrl: string | null
  parent: { id: string; name: string } | null
}

const fetcher = async (url: string): Promise<ObjectiveOption[]> =>
  await arcadeApiClient.get(url).then(res => res.data.objectives)

export const useObjectives = () => {
  const { data: objectives, isLoading: loading } = useSWR(
    '/multi_platform/manage/objectives',
    fetcher,
  )

  return { objectives: objectives || [], loading }
}
